function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M99.993 29.787h-9.6371l-2.0301-15.3985s-1.0276-8.768-2.0672-9.8707C84.9594 3.1404 83.3473 3 83.3473 3h-66.794s-1.611.1404-2.9112 1.5178c-1.0386 1.1028-2.0682 9.8707-2.0682 9.8707L9.543 29.787H0v14.9393l7.4145 1.189-.9694 7.3494v40.6826c0 1.9098 1.5489 3.4627 3.4617 3.4627h6.3007c1.9148 0 3.4647-1.5529 3.4647-3.4627v-9.626h60.5594v9.626c0 1.9098 1.5488 3.4627 3.4616 3.4627h6.3018c1.9127 0 3.4616-1.5529 3.4616-3.4627V53.2647l-.9674-7.3334 7.5058-1.204V29.787h-.002zM23.497 66.6072c-2.9818 0-5.3977-2.415-5.3977-5.3967 0-2.9808 2.4168-5.3967 5.3975-5.3967 2.98 0 5.3968 2.4168 5.3968 5.3967 0 2.9818-2.4158 5.3967-5.3967 5.3967zm53.388 0c-2.9809 0-5.3967-2.415-5.3967-5.3967 0-2.9808 2.4167-5.3967 5.3967-5.3967s5.3976 2.4168 5.3976 5.3967c0 2.9818-2.4176 5.3967-5.3975 5.3967h-.0001zm-63.9035-25.892l2.793-24.7448h68.03l3.1088 24.7449H12.9815z",
  fillRule: "nonzero"
});

var SvgVan = function SvgVan(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgVan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/van.e35ee442.svg";
export { ForwardRef as ReactComponent };